import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  static properties = {}

  constructor() {
    super()

    this.onSubmitHandler = this.onSubmitHandler.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')

    this.form.addEventListener('submit', this.onSubmitHandler)

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.form?.removeEventListener('submit', this.onSubmitHandler)

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    reRenderShopifySections(
      await addToCart(JSON.parse(serializeForm(this.form)))
    )

    this.dispatchEvent(
      new CustomEvent('drawer', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'mini-cart',
        },
      })
    )

    window.affirm?.ui.refresh && window.affirm.ui.refresh()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
